// extracted by mini-css-extract-plugin
export var content = "_67-1";
export var modal = "_67-0";